/** @module csi/sessionActions */
define([
    "dojo/has",
    "csi",
	"csi/comm/PostRequest",
	"csi/keycloak/KeycloakAdapter"
], function (has, csi, PostRequest, KeycloakAdapter) {

    // Boolean: single sign on identity provider redirect
    var _ssoIdentityProviderLoginEnabled = has("csi-sso-identity-provider-login");

    // String: default login page
    var _defaultLoginUrl = "login.html";

    // String: single sign on identity provider redirect path
    var _defaultSSOIdentityProviderRedirectPath = "../csi-requesthandler/sso/idp-redirect";
    

    // String: single sign on identity provider custom redirect path
    var _customSSOIdentityProviderRedirectPath = has("csi-sso-identity-provider-custom-url");

    return {

        redirectPage: function (/*Boolean?*/bHash,/*String*/location) {
            // redirects the page to given location
            var hash = bHash ? window.location.hash : "";
            window.location = csi.url(location) + ((hash == "#") ? "" : hash);
        },

        loginPage: function (/*Boolean?*/bHash) {
            // summary: switch to login page with existing hash if so indicated
            if (_ssoIdentityProviderLoginEnabled) {
                window.location = _customSSOIdentityProviderRedirectPath || csi.url(_defaultSSOIdentityProviderRedirectPath);
            } else {
                this.redirectPage(bHash, _defaultLoginUrl);
            }
        },

        logoutAction: async function () {
			try {
				await KeycloakAdapter.logout();
				await new PostRequest("DataSource", "SimpleLogout").post({});
			} finally {
				this.loginPage(false);
			}
        }
    };
});
